module.exports = __webpack_public_path__ + "img/payment-logo-visa-mc.14403854.png";